<script setup>
import BacklinkForm from "@frontJs/components/forms/projectManagement/seo/BacklinkForm.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  tenant: {
    type: Object,
    required: true,
  },
  websiteVariants: {
    type: Array,
    required: true,
  },
  seoBacklink: {
    type: [Object, null],
    required: false,
    default: null,
  },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title v-if="props.seoBacklink">
      {{ props.tenant.name }} -
      {{ t("title.updateBacklink", { id: props.seoBacklink.id }) }} -
      {{ t("title.seo") }} - {{ t("title.projectManagement") }} -
      {{ t("title.datakepler") }}
    </title>

    <title v-else>
      {{ t("title.createBacklink") }} - {{ t("title.seo") }} -
      {{ t("title.projectManagement") }} - {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle v-if="props.seoBacklink">
    {{ t("title.projectManagement") }} - {{ t("title.seo") }} -
    {{ t("title.updateBacklink", { id: props.seoBacklink.id }) }} -
    {{ tenant.name }}
  </PageTitle>

  <PageTitle v-else>
    {{ t("title.projectManagement") }} - {{ t("title.seo") }} -
    {{ t("title.createBacklink") }} - {{ tenant.name }}
  </PageTitle>

  <BacklinkForm :tenant="props.tenant" :website-variants="props.websiteVariants" :seo-backlink="props.seoBacklink" />
</template>
